import { atom } from 'jotai';

import { LANDING_PAGE_VIEWS } from '@shared/config/constants/app';

export type GlobalState = {
  theme: string;
  landingPageView: string;
};

const initialState: GlobalState = {
  theme: 'dark',
  landingPageView: LANDING_PAGE_VIEWS.MAIN,
};

export const globalAtom = atom<GlobalState>(initialState);
